module.exports = __webpack_public_path__ + "img/head-static_bg.8fa32e02.png";